import { AppState } from 'Store'
import { createSelector } from 'reselect'

const selectItems = (state: AppState) => state.pp.contractsRegistry.data
const selectRequestParams = (state: AppState) => state.pp.contractsRegistry.requestParams
const selectIsLoading = (state: AppState) => state.pp.contractsRegistry.loading
const selectFiltersTranslate = (state: AppState) => state.pp.contractsRegistry.filtersTranslate
const selectTotalEntries = (state: AppState) => state.pp.contractsRegistry.data?.total_entries
const selectFaces = (state: AppState) => state.pp.contractsRegistry.contactFaces
const selectFacesMap = createSelector(selectFaces, (faces) => {
	return faces.reduce((map, face) => {
		if (map.has(face.fio)) {
			const oldData = map.get(face.fio)
			map.set(face.fio, {
				emails: [...new Set([...oldData.emails, face.email])],
				phones: [...new Set([...oldData.phones, face.phone])],
			})
		} else {
			map.set(face.fio, {
				emails: [face.email],
				phones: [face.phone],
			})
		}
		return map
	}, new Map())
})

export const contractsRegistrySelectors = {
	selectItems,
	selectRequestParams,
	selectIsLoading,
	selectFiltersTranslate,
	selectTotalEntries,
	selectFacesMap,
}
